export default "__VITE_ASSET__BBXKTri___"